import {toCanvas} from 'bwip-js/browser'

/**
 * Data Matrix content. Agreed for now: prescription number + patient identifier.
 * Pending confirmation with Nick (Figma: "content to be confirmed"); change only here.
 */
export function getDataMatrixPayload(
  productionNumber: string,
  patient: {id: string; hospitalPatientId: string | null}
) {
  return `${productionNumber}|${patient.hospitalPatientId || patient.id}`
}

/** Code 128, 8 mm tall, for scanners that read no 2D codes */
export function renderCode128Png(text: string) {
  const canvas = document.createElement('canvas')
  toCanvas(canvas, {bcid: 'code128', text, scale: 6, height: 8, paddingwidth: 0, paddingheight: 0})
  return canvas.toDataURL('image/png')
}

export function renderDataMatrixPng(text: string) {
  const canvas = document.createElement('canvas')
  toCanvas(canvas, {bcid: 'datamatrix', text, scale: 6, paddingwidth: 0, paddingheight: 0})
  return canvas.toDataURL('image/png')
}
